import { useState } from 'react'
import { Button, Stack, TypographyProps } from '@mui/material'

import Plus from 'assets/icons/Plus Button.png'

import { StyledTableCell } from '../invoice-table-body'
import InvoiceDocumentsDialog from './invoice-documents-dialog/invoice-documents-dialog.component'
import { InvoiceType } from 'store/invoices/invoices.types'

type InvoiceTableCellProps = {
  disabled?: boolean
  orderId: string
  invoiceId: string
  invoiceType: InvoiceType
} & TypographyProps

const InvoiceTableDocuments = ({
  minWidth,
  align,
  orderId,
  invoiceId,
  invoiceType,
}: InvoiceTableCellProps) => {
  const [listOpen, setListOpen] = useState(false)

  return (
    <>
      <StyledTableCell sx={{ minWidth }} align={align}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <img
            src={Plus}
            alt="plus"
            width={34}
            height={34}
            style={{ cursor: 'pointer' }}
            onClick={() => setListOpen(true)}
          />
          <Button
            sx={{
              height: '36px',
              borderRadius: '6px',
              textTransform: 'capitalize',
            }}
            variant="contained"
            onClick={() => setListOpen(true)}
          >
            View
          </Button>
        </Stack>
      </StyledTableCell>

      <InvoiceDocumentsDialog
        orderId={orderId}
        invoiceId={invoiceId}
        invoiceType={invoiceType}
        open={listOpen}
        handleClose={() => setListOpen(false)}
      />
    </>
  )
}

export default InvoiceTableDocuments
